import styled from 'styled-components';

export const StyledCheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  pointer-events: ${({ disabled }) => disabled ? 'none' : ''};
  width: ${({ fullWidthLabel }) => fullWidthLabel ? '100%' : ''};
  label {
    margin: 0;
    width: ${({ fullWidthLabel }) => fullWidthLabel ? '100%' : 'fit-content'};

    span:nth-child(2) {
      width: ${({ fullWidthLabel }) => fullWidthLabel ? '100%' : ''}
    }
  }
  .disabled {
    border-color: #a9a9a9 !important;
  }
  .checkbox {
    img {
      // width: ${props => `${props.size / 1.5}px`};
    }
  }
  .checked {
    background-color: #7D97FF;
    transition: background-color .2s ease-in;
    img {
      width: ${props => `${props.imgSize}px`};
    }
  }
`